// The designer has no disabled state for a step type, so a step that can no
// longer be added (such as an AI step when the organization has turned AI off)
// but is already in a workflow is greyed out with a stylesheet keyed on the
// `sqd-type-<type>` class the designer puts on canvas steps.

const SAFE_TYPE = /^[a-z0-9_]+$/;

export function unavailableStepsCss(types) {
  const selectors = types
    .filter((type) => SAFE_TYPE.test(type))
    .map((type) => `.sqd-step-task.sqd-type-${type}`);

  return selectors.length === 0 ? "" : `${selectors.join(",\n")} { opacity: 0.45; }`;
}
